
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { AppStoreReducer } from './reducer';
import { AppStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, AppStoreReducer),
		EffectsModule.forFeature([AppStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppStoreModule { }
